import React, { useContext, useEffect } from 'react';

import { MapPopup } from './MapPopup';
import { Checkbox, Stack } from 'office-ui-fabric-react';
import { mapContext } from './mapContext';
import { useSelector } from 'react-redux';
import { IRootState } from 'reducer';
import { ITransportType } from 'reducer/user';
import { MapLayers } from './MapPage.types';

export const Layers: React.FC = () => {
  const {
    layers,
    showLayersPopup,
    toggleShowLayersPopup,
    setLayers,
  } = useContext(mapContext);

  if (!showLayersPopup) return null;

  return (
    <MapPopup label="Слои на карте" onClose={toggleShowLayersPopup}>
      <Stack
        tokens={{
          childrenGap: 32,
        }}
      >
        {(Object.keys(layers) as (keyof MapLayers)[]).map((layer) => (
          <Checkbox
            label={layers[layer]?.title}
            key={layer}
            checked={layers[layer]?.active}
            onChange={() =>
              setLayers((prevLayers) => {
                const prevValue = prevLayers[layer];
                return {
                  ...prevLayers,
                  [layer]: {
                    ...prevValue,
                    active: !prevValue?.active,
                  },
                };
              })
            }
          />
        ))}
      </Stack>
    </MapPopup>
  );
};
